import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class SettlementMethodQueryCriteriaClass extends BaseCriteriaModel {
  // Header table
  category?: Optional<string> = Optional.empty();
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();

  // Ext table
  item_hdr_guid?: Optional<string> = Optional.empty();
  ext_type?: Optional<string> = Optional.empty();
  ext_code?: Optional<string> = Optional.empty();
  ext_option?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_file?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
}

export class SettlementMethodCriteriaModelQuery {
  query = '';

  constructor(settlementMethodCriteriaModel: SettlementMethodQueryCriteriaClass) {

    if (!settlementMethodCriteriaModel) {
      return;
    }

    this.query += settlementMethodCriteriaModel.category.filter(x => x !== '').map(x => '&category=' + x).orElse('');
    this.query += settlementMethodCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += settlementMethodCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');

    this.query += settlementMethodCriteriaModel.item_hdr_guid.filter(x => x !== '').map(x => '&item_hdr_guid=' + x).orElse('');
    this.query += settlementMethodCriteriaModel.ext_type.filter(x => x !== '').map(x => '&ext_type=' + x).orElse('');
    this.query += settlementMethodCriteriaModel.ext_code.filter(x => x !== '').map(x => '&ext_code=' + x).orElse('');
    this.query += settlementMethodCriteriaModel.ext_option.filter(x => x !== '').map(x => '&ext_option=' + x).orElse('');
    this.query += settlementMethodCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += settlementMethodCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += settlementMethodCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += settlementMethodCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += settlementMethodCriteriaModel.value_file.filter(x => x !== '').map(x => '&value_file=' + x).orElse('');
    this.query += settlementMethodCriteriaModel.value_numeric.filter(x => x != null).map(x => '&value_numeric=' + x).orElse('');

    this.query += '&status=' + settlementMethodCriteriaModel.status;
    this.query += '&orderBy=' + settlementMethodCriteriaModel.orderBy;
    this.query += '&order=' + settlementMethodCriteriaModel.order;
    this.query += '&offset=' + settlementMethodCriteriaModel.offset + '&limit=' + settlementMethodCriteriaModel.limit;
  }
}
